<template>
  <div class="search-field">
    <dn-button
      v-track-event="{ eventName: 'Search submit', component: { zone: 'header', element: 'dn-search-submit' } }"
      class="button-search"
      icon="search"
      @click.prevent="doDnSearch"
    />
    <input
      v-model="searchText"
      type="search"
      :placeholder="t('Search')"
      @keyup.enter="doDnSearch"
    >
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();

const searchText = ref('');
const rtConfPub = useRuntimeConfig().public;

function doDnSearch () {
  const searchLink = rtConfPub?.config?.component?.searchLink;
  const encodedSearch = encodeURIComponent(searchText.value);
  window.location.href = `${searchLink}${encodedSearch}`;
}
</script>

<style lang="scss" scoped>
.search-field {
  display: none;
  background-color: var(--color-neutral-50);
  border-radius: 30px;
  padding: 14px 30px;

  @media only screen and (width >= 980px) {
    display: flex;
    width: var(--content-width);
    margin: 0 16px;
  }

  .menu-wrapper & {
    display: flex;
    inline-size: min(var(--page-width, 1280px), 100vw - var(--site-padding, 1rem) * 2);
    margin: 24px auto 0;

    @media only screen and (width >= 980px) {
      display: none;
    }
  }

  input {
    background: none;
    border: none;
    width: 100%;
    font-size: 16px;
    color: var(--color-neutral-700);
    line-height: 16px;
    outline: none;
    padding-left: 8px;
  }

  .button-search {
    display: flex;
    font-size: var(--typography-utility-s-font-family);
    line-height: 1;
    padding: 0;

    .dn-icon {
      stroke-opacity: 0.5;
      margin-right: 0;
    }
  }
}
</style>
